import { colors } from '../../colors';
var form = {
  bgColor: colors.white,
  labelColor: colors.darkNight,
  errorColor: colors.warningRed,
  borderColor: colors.darkNight,
  linkColor: colors.clearBlue,
  documentFormBgColor: colors.white,
  textColorDark: colors.darkNight,
  textColorLight: colors.white
};
export default form;